<template>
  <fieldset>
    <p>För mer instruktioner om hur du tar fram dessa inställningar, se <a href="https://developer.briqpay.com/docs/3.0.0/">Briqpay dokumentation.</a></p>
    <p>OBS! Det är ej lämpligt att koppla fler än en integration av denna typ till en profil.</p>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Miljö</div>
      </div>
      <select class="custom-select" required v-model="environment" @change="onUpdate">
        <option value="production">Produktionsmiljö</option>
        <option value="playground">Testmiljö</option>
      </select>
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Produkttyp</div>
      </div>
      <select class="custom-select" required v-model="defaultProductType" @change="onUpdate">
        <option value="physical">Fysisk produkt</option>
        <option value="digital">Digital produkt</option>
      </select>
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Username</div>
      </div>
      <input type="text" class="form-control" required v-model="username" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Key</div>
      </div>
      <input type="text" class="form-control" required v-model="key" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Product ID</div>
      </div>
      <input type="text" class="form-control" required v-model="productId" @input="onUpdate" format="^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Länk till era köpvilkor</div>
      </div>
      <input type="url" class="form-control" required v-model="termsUrl" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: Adressrad 1</div>
      </div>
      <input type="text" class="form-control" required v-model="fieldAddress1" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: Adressrad 2</div>
      </div>
      <input type="text" class="form-control" v-model="fieldAddress2" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: Postnr</div>
      </div>
      <input type="text" class="form-control" required v-model="fieldZipCode" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: City</div>
      </div>
      <input type="text" class="form-control" required v-model="fieldCity" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: ID. nr</div>
      </div>
      <input type="text" class="form-control" v-model="fieldIdNumber" @input="onUpdate">
    </div>

  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const username = ref(null);
const key = ref(null);
const productId = ref(null);
const termsUrl = ref(null);
const environment = ref(null);
const defaultProductType = ref(null);
const fieldAddress1 = ref(null);
const fieldAddress2 = ref(null);
const fieldZipCode = ref(null);
const fieldCity = ref(null);
const fieldIdNumber = ref(null);
const serializedValue = computed(() => {
  return {
    username: username.value,
    key: key.value,
    product_id: productId.value,
    terms_url: termsUrl.value,
    environment: environment.value,
    default_product_type: defaultProductType.value,
    field_address1: fieldAddress1.value,
    field_address2: fieldAddress2.value,
    field_zip_code: fieldZipCode.value,
    field_city: fieldCity.value,
    field_id_number: fieldIdNumber.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    username.value = modelValue.value.username;
    key.value = modelValue.value.key;
    productId.value = modelValue.value.product_id;
    termsUrl.value = modelValue.value.terms_url;
    environment.value = modelValue.value.environment;
    defaultProductType.value = modelValue.value.default_product_type;
    fieldAddress1.value = modelValue.value.field_address1;
    fieldAddress2.value = modelValue.value.field_address2;
    fieldZipCode.value = modelValue.value.field_zip_code;
    fieldCity.value = modelValue.value.field_city;
    fieldIdNumber.value = modelValue.value.field_id_number;
  }
  if (!fieldAddress1.value) {
    fieldAddress1.value = 'Adress';
  }
  if (!fieldZipCode.value) {
    fieldZipCode.value = 'Postnummer';
  }
  if (!fieldCity.value) {
    fieldCity.value = 'Ort';
  }
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    onUpdate();
  }
}, {
  immediate: true
});
</script>
